import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TrainingZonesCalculator"] */ "/opt/buildhome/repo/src/components/tools/training-zones-calculator.tsx");
